const usePlayground = () => {
    const menuList = [
        {
            name: 'Adminpoly',
            path: '/playground/adminpoly',
        },
        {
            name: 'Am Chart',
            path: '/playground/amChart',
        },
        {
            name: 'Button',
            path: '/playground/button',
        },
        {
            name: 'Carousel',
            path: '/playground/carousel',
        },
        {
            name: 'Checkbox',
            path: '/playground/checkbox',
        },
        {
            name: 'Data Table',
            path: '/playground/dataTable',
        },
        {
            name: 'Date Picker',
            path: '/playground/datePicker',
        },
        {
            name: 'Dialog',
            path: '/playground/dialog',
        },
        {
            name: 'Dialog Alert',
            path: '/playground/dialogAlert',
        },
        {
            name: 'Dialog Full Screen',
            path: '/playground/dialogFullScreen',
        },
        {
            name: 'Dropdown',
            path: '/playground/dropdown',
        },
        {
            name: 'Form Example',
            path: '/playground/formExample',
        },
        {
            name: 'Image Gallery',
            path: '/playground/ImageGallery',
        },
        {
            name: 'Loading',
            path: '/playground/loading',
        },
        {
            name: 'Map',
            path: '/playground/map',
        },
        {
            name: 'Menu Drawer',
            path: '/playground/menuDrawer',
        },
        {
            name: 'Radio Group',
            path: '/playground/radioGroup',
        },
        {
            name: 'Slick Carousel',
            path: '/playground/slickCarousel',
        },
        {
            name: 'Slider',
            path: '/playground/slider',
        },
        {
            name: 'Snackbar',
            path: '/playground/snackbar',
        },
        {
            name: 'Switch',
            path: '/playground/switch',
        },
        {
            name: 'Text Editor',
            path: '/playground/textEditor',
        },
        {
            name: 'Upload',
            path: '/playground/upload',
        },
    ]

    return {
        menuList,
    }
}

export default usePlayground
